module.exports = __webpack_public_path__ + "images/start-harmonie-muenchen-3-9decff205dabe68fb7a161469aa9dfb6.jpg";